import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.themoviedb.org/3/',
  params: {
    api_key: '761b201bf66269aa06a33c1d922810c2',
    language: 'ko'
  }
});

export const movieApi = {
  nowPlaying: () => api.get(`movie/now_playing`),
  popular: () => api.get('movie/popular'),
  topRated: () => api.get('movie/top_rated'),
  credits: id => api.get(`movie/${id}/credits`),
  recommend: id => api.get(`/movie/${id}/similar`),
  movieDetail: id =>
    api.get(`movie/${id}`, {
      params: {
        append_to_response: 'videos'
      }
    }),
  search: word =>
    api.get('search/movie', {
      params: {
        query: encodeURIComponent(word)
      }
    }),

  popularInfinite: page =>
    api.get('movie/popular', {
      params: {
        page: page
      }
    }),
  topRatedInfinite: page =>
    api.get('movie/top_rated', {
      params: {
        page: page
      }
    }),
  nowPlayingInfinite: page =>
    api.get(`movie/now_playing`, {
      params: {
        page: page
      }
    }),
  searchInfinite: (word, page) =>
    api.get('/search/movie', {
      params: {
        query: word,
        page: page
      }
    }),
  videos: id =>
    api.get(`
  /movie/${id}/videos`)
};

export const tvApi = {
  popular: () => api.get('tv/popular'),
  topRated: () => api.get('tv/top_rated'),
  airingToday: () => api.get('tv/airing_today'),
  credits: id => api.get(`tv/${id}/credits`),
  recommend: id => api.get(`/tv/${id}/similar`),
  tvDetail: id =>
    api.get(`tv/${id}`, {
      params: {
        append_to_response: 'videos'
      }
    }),
  search: word =>
    api.get('search/tv', {
      params: {
        query: encodeURIComponent(word)
      }
    }),
  popularInfinite: page =>
    api.get('tv/popular', {
      params: {
        page: page
      }
    }),
  airingTodayInfinite: page =>
    api.get('tv/airing_today', {
      params: {
        page: page
      }
    }),
  topRatedInfinite: page =>
    api.get('tv/top_rated', {
      params: {
        page: page
      }
    }),
  searchInfinite: (word, page) =>
    api.get('/search/tv', {
      params: {
        query: encodeURIComponent(word),
        page: page
      }
    })
};
